// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper___YNk9","fullScreen":"Loader_fullScreen__cQUz4","loader":"Loader_loader__DN9xi"};